import { useState, useEffect } from 'react';
import { fetchGerantStats } from '../api/analytics.api';
// import { fetchRecentActivities } from '../api/analytics.api'; // TODO: Décommenter une fois que l'endpoint /api/analytics/recent-activities/ sera disponible
import { fetchMySurveys } from '../api/survey.api';
import logger from '../utils/logger';

/**
 * Hook personnalisé pour gérer les données du dashboard gérant
 * Récupère les KPIs, sondages récents et activités récentes
 */
export function useGerantDashboard() {
  const [data, setData] = useState({
    kpis: null,
    surveys: [],
    activities: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadDashboardData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Charger les KPIs
        const kpisData = await fetchGerantStats();
        
        // Charger les sondages récents
        const surveysData = await fetchMySurveys({
          limit: 5,
          ordering: '-created_at'
        });

        // Normaliser les données des sondages
        let normalizedSurveys = [];
        if (Array.isArray(surveysData)) {
          normalizedSurveys = surveysData;
        } else if (surveysData?.results && Array.isArray(surveysData.results)) {
          normalizedSurveys = surveysData.results;
        } else if (surveysData?.data && Array.isArray(surveysData.data)) {
          normalizedSurveys = surveysData.data;
        }

        // TODO: Charger les activités récentes
        // L'endpoint /api/analytics/recent-activities/ n'est pas encore disponible
        // À décommenter une fois que l'endpoint sera implémenté
        // const activitiesData = await fetchRecentActivities({
        //   limit: 10
        // });

        setData({
          kpis: kpisData,
          surveys: normalizedSurveys,
          activities: [] // Temporairement vide en attendant l'endpoint
        });

        logger.log('Dashboard data loaded successfully', {
          kpis: kpisData,
          surveysCount: normalizedSurveys.length,
          activitiesCount: 0 // Endpoint non disponible
        });
      } catch (err) {
        logger.error('Error loading dashboard data:', err);
        setError(err.message || 'Erreur lors du chargement des données');
      } finally {
        setLoading(false);
      }
    };

    loadDashboardData();
  }, []);

  return {
    data,
    loading,
    error,
    kpis: data.kpis,
    surveys: data.surveys,
    activities: data.activities
  };
}
